/**
 * The tab a chart window opens on, asked for by the dashboard button that
 * opens it (card / list row / Actions menu: Intake and Vitals ask for Vitals,
 * Chart clears any request).
 *
 * Why (review 10-07): in a practice whose CareIQ tab is N3-only (7825), an
 * "n3" chart opens on CareIQ. Intake opened that chart and only then, 50-100 ms
 * later, moved it to Vitals by the "navigateToPriorVitals" event, so every
 * Intake click mounted the CareIQ tab and fired its whole fetch set (v2 GET,
 * document lists, encounters, procedures, orders, recordings) for nothing.
 *
 * One request at a time, read by the next chart that mounts for the SAME
 * patient within START_TTL_MS; an older request, or one for another patient,
 * is ignored (the chart opens on its default tab and the button's event moves
 * it, exactly as before). Only a practice whose CareIQ tab is N3-only reads it
 * (patientchartwrap); 9928 opens as before. The buttons keep their events, so
 * Intake's sub-tab (internalTab) is set the same way as before.
 */
const START_TTL_MS = 5000;
let pending = null;

// `tab` null / undefined (or no patient) clears the request.
export function requestChartStartTab(patientid, tab) {
  pending = patientid != null && patientid !== "" && tab != null
    ? { patientid: String(patientid), tab, at: Date.now() }
    : null;
}

// The requested tab for this patient's chart, or null. Does not clear it
// (React may call a state initializer twice); the chart clears it once mounted.
export function peekChartStartTab(patientid) {
  const p = pending;
  if (!p || patientid == null || p.patientid !== String(patientid)) return null;
  if (Date.now() - p.at > START_TTL_MS) return null;
  return p.tab;
}

export function clearChartStartTab() {
  pending = null;
}
